import React, { useContext } from "react"

import { NavPanelContext } from "../../contexts/NavPanelContext"
import ThemeToggler from "../ThemeToggler"
import NavLink from "./NavLink"
import SocialBar from "../SocialBar"
import DownloadBtn from "../DownloadBtn"
import { NAV_ITEMS } from "../../constants"

export default function NavPanel() {
    const { showPanel } = useContext(NavPanelContext)

    return (
        <aside className={showPanel ? "nav-panel show" : "nav-panel"}>
            <section>
                <ThemeToggler />
            </section>

            <section>
                {
                    NAV_ITEMS.map(({ name }) => (
                        <NavLink key={name} name={name} classN="nav-link" />
                    ))
                }
            </section>

            <section>
                <DownloadBtn />
            </section>

            <section>
                <SocialBar />
            </section>
        </aside>
    )
}
